<template>
    <div>
        <div class="card">
            <div class="card-body card-body--tab">
                <ul class="tabs-ul">
                    <li
                        class="tab"
                        :class="{ 'tab--active': tab.isActive }"
                        :key="index"
                        v-for="(tab, index) in tabs"
                    >
                        <a :href="tab.href" @click="selectTab(tab)">{{ tab.nameTab }}</a>
                    </li>
                </ul>
            </div>
        </div>

        <br/>

        <div class="tabs-details">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Tabs',

  data () {
    return { tabs: [] }
  },

  created () {
    this.tabs = this.$children

  },
  methods: {
    selectTab (selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = (tab.nameTab == selectedTab.nameTab)
      })
    }
  }
}
</script>
